import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import { BASE_URL, PROMOTION_LIST, PROMOTION_CREATE, PROMOTION_UPDATE, PROMOTION_DELETE, M_POST } from '@/utils/api';

@Module({ name: 'promotion' })
export default class Promotion extends VuexModule {
  list: any = [];

  @Mutation
  mutatePromotion(promotion: any) {
    this.list = promotion;
  }

  @Action({ commit: 'mutatePromotion', rawError: true })
  async FetchPromotion() {
    try {
      const { data } = await axios({
        url: BASE_URL + PROMOTION_LIST,
        method: M_POST,
        data: {}
      });

      assertOk(data, 'Fetch promotion failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch promotion failed');
    }
  }

  @Action({ rawError: true })
  async AddPromotion(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + PROMOTION_CREATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Add promotion failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Add promotion failed');
    }
  }

  @Action({ rawError: true })
  async EditPromotion(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + PROMOTION_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Edit promotion failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Edit promotion failed');
    }
  }

  @Action({ rawError: true })
  async DeletePromotion(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + PROMOTION_DELETE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Delete promotion failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Delete promotion failed');
    }
  }
}
